<template>
  <v-simple-table :v-bind="$attrs">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Descripcion</th>
          <th class="text-left">Tipo de Descuento</th>
          <th class="text-left">Descuento</th>
          <th class="text-left">Disponible para</th>
          <th class="text-left">Visible por</th>
          <th class="text-left"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="discount in discounts" :key="discount._id">
          <td>{{ discount.description_method_discount }}</td>
          <td>
            {{ valueMethodDiscount[discount.method_discount] }}
          </td>
          <td>
            {{
              printDiscountValue(discount.discount, discount.method_discount)
            }}
          </td>
          <td>
            <v-chip
              v-if="discount.propertys_code.length === 0"
              small
              outlined
              color="primary"
            >
              Todas las propiedades
            </v-chip>
            <SimpleGroupChip v-else :value="discount.propertys_code" />
          </td>
          <td>
            <SimpleGroupChip
              :value="discount.allowed_entities.map(formatAllowedEntities)"
              style="text-transform: capitalize;"
            />
          </td>
          <td>
            <v-icon @click="handleEdit(discount)" class="mr-2" color="primary">
              mdi-pencil
            </v-icon>
            <v-icon
              @click="handleDelete(discount)"
              class="mr-2"
              color="red darken-4"
            >
              mdi-delete
            </v-icon>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
export default {
  name: "DiscountTable",
  components: {
    SimpleGroupChip: () => import("@/components/common/chip/group.vue")
  },
  props: {
    discounts: { type: Array, required: true, default: () => [] }
  },
  data: () => ({
    valueMethodDiscount: {
      percentage: "Porcentaje",
      fixed: "Fijo"
    }
  }),
  methods: {
    printDiscountValue(discount, type_discount) {
      if (discount) {
        return type_discount === "percentage" ? `${discount}%` : `$${discount}`;
      }
      return "-";
    },
    formatAllowedEntities(entity) {
      if (entity.includes("role")) {
        return entity.replace("role:", "");
      }
      return entity;
    },
    handleEdit(discount) {
      this.$emit("edit", discount);
    },

    handleDelete(discount) {
      this.$emit("delete", discount);
    }
  }
};
</script>
<style lang=""></style>
